import * as React from "react";
import { formatMetricNumber } from "common/util";
import { LENGTH, SIZE, TEXT_HIGHLIGHT_THEME, TextHighlightReact } from "common/components/text-highlight";
import { TooltipReact } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
import { LIFT_TOOLTIP_COMPARE } from "common/report/util/lift/types";
import { formatLiftPercent } from "common/report/util/lift";
import { formatNumber } from "common/report/retention/util";
export function getDataCellRenderer(hasLift, bookmarkController) {
  return function(props) {
    const item = props.item;
    const context = props.context;
    const cell = item.cells.length > context.field ? item.cells[context.field] : null;
    if (cell) {
      const isPct = bookmarkController.isPercentageView(item.matchingShowClauseIndex);
      const mainDisplayValue = isPct ? cell.formatted_percent : cell.formatted_value;
      const coreCellContent = `${mainDisplayValue}${cell.incomplete ? `*` : ``}`;
      if (hasLift) {
        const liftField = item[context.liftField];
        const liftExtra = item[context.liftExtra];
        const isPositive = liftField > 0;
        const tooltipBaselineDisplayValue = isPct ? `${formatMetricNumber(Number((100 * liftExtra).toFixed(2)))}%` : `${formatNumber(liftExtra)}`;
        return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
          className: `mp-table-cell`
        }, coreCellContent, /* @__PURE__ */ React.createElement(TextHighlightReact, {
          className: `mp-lift-pill`,
          length: LENGTH.THIN,
          size: SIZE.SMALL,
          text: formatLiftPercent(liftField),
          theme: isPositive ? TEXT_HIGHLIGHT_THEME.POSITIVE : TEXT_HIGHLIGHT_THEME.NEGATIVE
        }), /* @__PURE__ */ React.createElement(TooltipReact, {
          placement: Placement.Top,
          text: `${mainDisplayValue} ${LIFT_TOOLTIP_COMPARE} ${tooltipBaselineDisplayValue}`
        })));
      }
      return coreCellContent;
    }
    return void 0;
  };
}
